// Product card code (quick add + photo strip). Moved out of snippets/card-product.liquid, where every card
// printed its own copy (87 copies on the homepage). Loaded once per page from layout/theme.liquid.
  
  
  class VariantQuickAdd extends HTMLElement {
    constructor() {
      super();
      this.isProcessing = false;
      this.lastClickTime = 0;
      this.clickDelay = 300; // Minimum time between submissions in ms
      this._handleSubmit = this.handleSubmit.bind(this);
    }
  
    connectedCallback() {
      if (!this.hasAttribute('initialized')) {
        this.setAttribute('initialized', '');
        this.bindEvents();
      }
    }
  
    disconnectedCallback() {
      this.removeEvents();
      // Sliders (Swiper loop) move cards around the page: allow binding again when the card is re-attached
      this.removeAttribute('initialized');
    }
  
    bindEvents() {
      this.addEventListener('submit', this._handleSubmit);
    }
  
    removeEvents() {
      this.removeEventListener('submit', this._handleSubmit);
    }
  
    shouldHandleSubmit() {
      const now = Date.now();
      if (now - this.lastClickTime < this.clickDelay || this.isProcessing) {
        return false;
      }
      this.lastClickTime = now;
      return true;
    }
  
    async handleSubmit(event) {
      if (!this.shouldHandleSubmit()) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
  
      event.preventDefault();
      event.stopPropagation();
      
      const form = event.target;
      const submitButton = form.querySelector('button[type="submit"]');
      if (!submitButton) return;
  
      this.isProcessing = true;
      submitButton.disabled = true;
  
      try {
        const variantId = form.querySelector('input[name="id"]').value;
        
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: Number(variantId),
              quantity: 1
            }]
          })
        });
  
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.description || 'Error adding to cart');
        }
  
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          const [sectionsResponse, cartResponse] = await Promise.all([
            fetch(`${window.Shopify.routes.root}cart?view=drawer`),
            fetch(`${window.Shopify.routes.root}cart.js`)
          ]);
  
          const sectionHTML = await sectionsResponse.text();
          const cart = await cartResponse.json();
  
          cartDrawer.classList.remove('is-empty');
          
          const drawerInner = cartDrawer.querySelector('.drawer__inner');
          if (drawerInner) {
            if (!drawerInner.innerHTML.trim()) {
              drawerInner.innerHTML = sectionHTML;
            }
            drawerInner.classList.remove('is-empty');
          }
  
          cartDrawer.renderContents({
            sections: { 'cart-drawer': sectionHTML },
            id: variantId,
            item_count: cart.item_count
          });
  
          requestAnimationFrame(() => {
            cartDrawer.classList.add('active', 'animate');
          });
  
          const cartCountBubble = document.querySelector('.cart-count-bubble');
          if (cartCountBubble) {
            const cartCount = cartCountBubble.querySelector('span');
            if (cartCount) {
              cartCount.textContent = cart.item_count;
            }
            cartCountBubble.style.display = cart.item_count > 0 ? 'flex' : 'none';
          }
        }
  
      } catch (error) {
        console.error('Error:', error);
      } finally {
        // Reset state after a delay to prevent rapid resubmission
        setTimeout(() => {
          this.isProcessing = false;
          submitButton.disabled = false;
        }, this.clickDelay);
      }
    }
  }
  
  if (!customElements.get('variant-quick-add')) {
    customElements.define('variant-quick-add', VariantQuickAdd);
  }
  
  // Initialize custom elements
  
  
  
  
  // Initialize the quick add functionality once

    // Card photo strip: arrows scroll one photo; each arrow hides at its end. Works for cards loaded later (filters).
    if (!window.soCardSwipe) {
      window.soCardSwipe = true;
      const update = (track) => {
        const box = track.closest('[data-card-swipe]');
        if (!box) return;
        box.querySelector('[data-dir="-1"]').hidden = track.scrollLeft < 4;
        box.querySelector('[data-dir="1"]').hidden = track.scrollLeft + track.clientWidth > track.scrollWidth - 4;
      };
      // A swipe is never a tap: if the finger moved (or the strip just scrolled), the product doesn't open — also at the
      // last photo, where there's nothing left to scroll (Joris 20 Oct).
      let start = null, moved = false, lastScroll = 0;
      // Photos 2–5 of a strip only get their source when needed (mobile speed, 26 Oct): all of them on the first touch or
      // arrow tap; photo 2 already for strips on screen once the page has finished loading (so the first swipe is smooth).
      // nextOnly: just the next photo (card seen on screen); otherwise all (card touched).
      const loadStrip = (box, nextOnly) => {
        if (!box || box.dataset.loaded) return;
        if (!nextOnly) box.dataset.loaded = '1';
        const waiting = box.querySelectorAll('img[data-srcset]');
        (nextOnly ? [...waiting].slice(0, 1) : waiting).forEach((img) => {
          img.srcset = img.dataset.srcset;
          img.src = img.dataset.src;
          img.removeAttribute('data-srcset');
        });
      };
      const onScreen = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => { if (entry.isIntersecting) { loadStrip(entry.target, true); onScreen.unobserve(entry.target); } });
      }) : null;
      const watchStrips = () => document.querySelectorAll('[data-card-swipe]:not([data-loaded]):not([data-watched])').forEach((box) => {
        box.dataset.watched = '1';
        if (onScreen) onScreen.observe(box); else loadStrip(box, true);
      });
      const startWatching = () => {
        watchStrips();
        // Cards added later (filters, Shop the look, recently viewed) are picked up too
        new MutationObserver(watchStrips).observe(document.body, { childList: true, subtree: true });
      };
      if (document.readyState === 'complete') startWatching(); else window.addEventListener('load', startWatching);
      document.addEventListener('touchstart', (e) => {
        if (!e.target.closest('[data-card-swipe]')) return;
        loadStrip(e.target.closest('[data-card-swipe]'));
        start = { x: e.touches[0].clientX, y: e.touches[0].clientY };
        moved = false;
      }, { passive: true, capture: true });
      document.addEventListener('touchmove', (e) => {
        if (!start) return;
        if (Math.abs(e.touches[0].clientX - start.x) > 8 || Math.abs(e.touches[0].clientY - start.y) > 8) moved = true;
      }, { passive: true, capture: true });
      document.addEventListener('click', (e) => {
        const slide = e.target.closest('.so-card-swipe__slide');
        if (slide && (moved || Date.now() - lastScroll < 350)) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);
      document.addEventListener('click', (e) => {
        const arrow = e.target.closest('.so-card-swipe__arrow');
        if (!arrow) return;
        e.preventDefault();
        e.stopPropagation();
        loadStrip(arrow.closest('[data-card-swipe]'));
        const track = arrow.closest('[data-card-swipe]').querySelector('.so-card-swipe__track');
        track.scrollBy({ left: Number(arrow.dataset.dir) * track.clientWidth, behavior: 'smooth' });
        setTimeout(() => update(track), 450); // in case the browser sends no scroll event
      }, true);
      document.addEventListener('scroll', (e) => {
        if (e.target.classList && e.target.classList.contains('so-card-swipe__track')) {
          lastScroll = Date.now();
          update(e.target);
        }
      }, true);
    }
